import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const BoxLayout = (props) => {
  const { pageTitle, content, toolbarAction, className, contentClassName } =
    props;
  return (
    <Card elevation={1} square className={clsx("rounded", className)}>
      <CardHeader
        title={pageTitle}
        classes={{ title: "text-[16px] font-bold uppercase" }}
        sx={{ paddingX: "30px" }}
        action={toolbarAction}
      />
      <Divider />
      <CardContent className={contentClassName} sx={{ padding: "30px" }}>
        {content}
      </CardContent>
    </Card>
  );
};

// BoxLayout.defaultProps = {}

BoxLayout.propTypes = {
  pageTitle: PropTypes.any,
  content: PropTypes.any,
  toolbarAction: PropTypes.any,
};

export default React.memo(BoxLayout);
